/* eslint-disable no-bitwise */
import {
    SnapConstraints,
    DiagramTools,
    SelectorConstraints,
    DiagramConstraints
} from "@syncfusion/ej2-vue-diagrams";

const snapDistance = 8;
// grid config
const gridlines = {
    lineColor: "#E2E6EB",
    lineIntervals: [0.5, 7.5, 0.15, 7.85, 0.15, 7.85, 0.15, 7.85, 0.15, 7.85, 0.15, 7.85, 0.15, 7.85, 0.15, 7.85],
    snapIntervals: [snapDistance]
};

const snapSettings = {
    horizontalGridlines: gridlines,
    verticalGridlines: gridlines,
    gridType: "Lines",
    constraints: SnapConstraints.ShowLines | SnapConstraints.SnapToLines,
    snapObjectDistance: snapDistance
};

const handles = [
    {
        name: "drawConnector",
        pathData:
            // eslint-disable-next-line max-len
            "M438.6 278.6l-160 160C272.4 444.9 264.2 448 256 448s-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L338.8 288H32C14.33 288 .0016 273.7 .0016 256S14.33 224 32 224h306.8l-105.4-105.4c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160C451.1 245.9 451.1 266.1 438.6 278.6z",
        visible: false,
        backgroundColor: "#374051",
        pathColor: "white",
        offset: 0.5,
        side: "Top",
        margin: { top: 0, bottom: 0, left: 0, right: 0 }
    }
];

export const diagramConfig = {
    snapSettings,
    width: "100%",
    height: "100%",
    mode: "SVG",
    // mode: "Canvas",
    serializationSettings: { preventDefaults: true },
    tool: DiagramTools.SingleSelect | DiagramTools.ZoomPan,
    constraints: DiagramConstraints.Default,
    selectedItems: {
        userHandles: handles,
        constraints: SelectorConstraints.None
    },
    layout: {
        enableRouting: true
    },
    scrollSettings: {
        currentZoom: 1,
        minZoom: 0.1,
        maxZoom: 3,
        canAutoScroll: true,
        autoScrollBorder: { left: 350, right: 350, top: 160, bottom: 50 },
        scrollLimit: "Infinity"
    }
};
// eslint-disable-next-line max-len
export const key = "Mgo+DSMBaFt/QHRqVVhjVFpFdEBBXHxAd1p/VWJYdVt5flBPcDwsT3RfQF5jSH5XdkZnXn1dcXxQTw==;Mgo+DSMBPh8sVXJ0S0J+XE9HflRDX3xKf0x/TGpQb19xflBPallYVBYiSV9jS31Td0VnWXxad3ZWRGFdWA==;ORg4AjUWIQA/Gnt2VVhkQlFadVdJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxQdkRjXX9ddHNXRWJfUE0=;ODY5OTgyQDMyMzAyZTM0MmUzME56OEtoWFNFRGl2UjNEeVFPLzRTYmhrMy9wdkttV3Jmd1FCYS9BMjhCMjA9;ODY5OTgzQDMyMzAyZTM0MmUzMFJpNTc0di83Z0F0a2hubE1CQnBJYmRCME0zNVFBejhmTitNMmU3NFp2Mms9;NRAiBiAaIQQuGjN/V0Z+WE9EaFxKVmJLYVB3WmpQdldgdVRMZVVbQX9PIiBoS35RdUViWXtec3BSRGNfVUF/;ODY5OTg1QDMyMzAyZTM0MmUzMFFGaVNKa205MFdoTVZiUlZHRmptcklHeUtnR3MxV3BDenJ6WWhnRG5IQzQ9;ODY5OTg2QDMyMzAyZTM0MmUzMGJ6OGVJNklsU2RJeHBIOGUwNThWK1d1Z1RmempQTGkwa1hJTDhhcVFxSm89;Mgo+DSMBMAY9C3t2VVhkQlFadVdJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxQdkRjXX9ddHNXRWRZVU0=;ODY5OTg4QDMyMzAyZTM0MmUzMGFFUkV4bzJpdDdEK3RsamlPWHo2N2lPbWdiMjIxRXV4aCtKaDl4MFZHMTA9;ODY5OTg5QDMyMzAyZTM0MmUzMFdBMUZtYkZZV1Y3UElyTnFMUDhMZ0NaOGVGM3krb3pvVXVMcTRSTDFlekE9;ODY5OTkwQDMyMzAyZTM0MmUzMFFGaVNKa205MFdoTVZiUlZHRmptcklHeUtnR3MxV3BDenJ6WWhnRG5IQzQ9";
